import { Grid } from '@mui/material';
import { useSendSupportMessage } from '_api';
import { ContactSupportPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { DefaultContactSupportData } from '_constants/object-templates';
import { StyledFormLabel, StyledDetailDescription } from 'components/atoms';
import { AlertMessage, BaseModal } from 'components/molecules';
import React, { useState } from 'react';
import { useUser } from 'utils/hooks';

import { ContactSupportForm } from '../forms';

import { ModalProps } from './types';

export const ContactSupportModal = ({ open, onClose }: ModalProps) => {
  const { mutateAsync: sendMessage } = useSendSupportMessage();
  const { account } = useUser();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmit = (payload: ContactSupportPayload) => {
    sendMessage(payload)
      .then(() => {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 3500);
      })
      .catch((err) => {
        setErrorMessage(err.message);
        setShowError(true);
      });
  };

  return (
    <BaseModal open={open} title={'Contact Support'} onClose={onClose}>
      <Grid container sx={{ marginBottom: '10px' }}>
        <Grid item sm={3} xs={12}>
          <StyledFormLabel>FIRST NAME</StyledFormLabel>
          <StyledDetailDescription sx={{ marginLeft: '0.25rem' }}>
            {account?.firstName}
          </StyledDetailDescription>
        </Grid>
        <Grid item sm={3} xs={12}>
          <StyledFormLabel>LAST NAME</StyledFormLabel>
          <StyledDetailDescription sx={{ marginLeft: '0.25rem' }}>
            {account?.lastName}
          </StyledDetailDescription>
        </Grid>
        <Grid item sm={6} xs={12}>
          <StyledFormLabel>EMAIL</StyledFormLabel>
          <StyledDetailDescription sx={{ marginLeft: '0.25rem' }}>
            {account?.email}
          </StyledDetailDescription>
        </Grid>
      </Grid>
      <ContactSupportForm
        initValue={DefaultContactSupportData}
        onSubmit={onSubmit}
        onBack={onClose}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Support message successfully sent'}
      />
      <AlertMessage
        open={showError}
        onClose={() => setShowError(false)}
        severity={SEVERITY.error}
        message={
          <>
            An error occurred.
            <br />
            {errorMessage}
            <br />
            Please try again.
          </>
        }
      />
    </BaseModal>
  );
};
